import React, { Component } from "react";

class GenericNotFound extends Component {
    render() {
        const anchorStyle = {
            color: '#FF725E'
        }
        return (
            <div className="m-5 py-5 text-center">
              <h1 className="display-1">404</h1>
              <h3>PAGE NOT FOUND</h3>
              <p>THE PAGE MAY BE BROKEN, OR MAY HAVE BEEN REMOVED.</p>
              <a href={`/search-book`} style={anchorStyle}>CLICK HERE TO GO BACK TO SEARCH AND BOOK</a>
            </div>
        );
    }
}

export { GenericNotFound };
